import { useEffect, useState } from 'react'

import { Progress } from '@/components'

export default function Component() {
  const [value, setValue] = useState(Math.ceil(Math.random() * 30))

  function updateValue() {
    setValue((value) => {
      const newValue = value + Math.random() * 30
      return newValue > 100 ? 0 : Math.ceil(newValue)
    })
  }

  useEffect(() => {
    const interval = setInterval(updateValue, 1000)
    return () => clearInterval(interval)
  })

  return (
    <div className="mx-auto max-w-xl">
      <div className="flex h-screen flex-col items-center justify-center space-y-2">
        <Progress value={value} />
        <span>Carregando...</span>
      </div>
    </div>
  )
}
